import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function FAQ() {
  const { i18n } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      questionEn: 'What services does Kimberlite Commercial Brokerage provide?',
      questionAr: 'ما هي الخدمات التي تقدمها كيمبرلايت للوساطة التجارية؟',
      answerEn: 'We provide comprehensive commercial brokerage services including finding reliable suppliers and buyers, negotiating optimal commercial terms, preparing and monitoring contract implementation, providing business and market consulting, facilitating shipping and customs clearance, and assisting with company setup, banking transactions, and investor matchmaking.',
      answerAr: 'نقدم خدمات الوساطة التجارية الشاملة بما في ذلك العثور على موردين ومشترين موثوقين، والتفاوض على الشروط التجارية المثلى، وإعداد ومراقبة تنفيذ العقود، وتقديم الاستشارات التجارية والسوقية، وتسهيل الشحن والتخليص الجمركي، والمساعدة في تأسيس الشركات والمعاملات المصرفية والتوفيق بين المستثمرين.'
    },
    {
      questionEn: 'Where is Kimberlite based and what regions do you serve?',
      questionAr: 'أين يقع مقر كيمبرلايت وما هي المناطق التي تخدمونها؟',
      answerEn: 'We are headquartered in Doha, Qatar, and operate across the MENA region with extensive global reach. We facilitate international trade across Asia Pacific, Europe, and the Americas, connecting local demand with global supply through our extensive network.',
      answerAr: 'يقع مقرنا الرئيسي في الدوحة، قطر، ونعمل في جميع أنحاء منطقة الشرق الأوسط وشمال أفريقيا مع وصول عالمي واسع. نسهل التجارة الدولية عبر آسيا والمحيط الهادئ وأوروبا والأمريكتين، ونربط الطلب المحلي بالعرض العالمي من خلال شبكتنا الواسعة.'
    },
    {
      questionEn: 'How does Kimberlite ensure transparency in its operations?',
      questionAr: 'كيف تضمن كيمبرلايت الشفافية في عملياتها؟',
      answerEn: 'Transparency is one of our core values. We maintain clear communication throughout every transaction, provide honest assessments of market conditions, ensure all parties understand contract terms, and conduct rigorous vetting processes for all suppliers and buyers. Our commitment to openness builds lasting trust with our clients.',
      answerAr: 'الشفافية هي إحدى قيمنا الأساسية. نحافظ على التواصل الواضح طوال كل معاملة، ونقدم تقييمات صادقة لظروف السوق، ونضمن فهم جميع الأطراف لشروط العقد، ونجري عمليات فحص صارمة لجميع الموردين والمشترين. التزامنا بالانفتاح يبني ثقة دائمة مع عملائنا.'
    },
    {
      questionEn: 'Can Kimberlite help with company setup and banking in Qatar?',
      questionAr: 'هل يمكن لكيمبرلايت المساعدة في تأسيس الشركات والخدمات المصرفية في قطر؟',
      answerEn: 'Yes, we provide comprehensive support for company registration and setup in Qatar, facilitate banking transactions and account opening with local financial institutions, and help connect businesses with potential investors. Our deep understanding of Qatar\'s business environment ensures a smooth establishment process.',
      answerAr: 'نعم، نقدم دعمًا شاملاً لتسجيل وتأسيس الشركات في قطر، ونسهل المعاملات المصرفية وفتح الحسابات مع المؤسسات المالية المحلية، ونساعد في ربط الشركات بالمستثمرين المحتملين. فهمنا العميق لبيئة الأعمال في قطر يضمن عملية تأسيس سلسة.'
    },
    {
      questionEn: 'What makes Kimberlite different from other commercial brokers?',
      questionAr: 'ما الذي يميز كيمبرلايت عن الوسطاء التجاريين الآخرين؟',
      answerEn: 'Our unique combination of deep MENA market expertise, extensive global network, and unwavering commitment to transparency sets us apart. We act as a true strategic partner, not just a transaction facilitator. Our Qatar base gives us unique insights into regional markets while our international connections ensure optimal commercial terms for all parties.',
      answerAr: 'مزيجنا الفريد من الخبرة العميقة في أسواق الشرق الأوسط وشمال أفريقيا، والشبكة العالمية الواسعة، والالتزام الثابت بالشفافية يميزنا. نعمل كشريك استراتيجي حقيقي، وليس مجرد ميسر للمعاملات. قاعدتنا في قطر تمنحنا رؤى فريدة للأسواق الإقليمية بينما تضمن اتصالاتنا الدولية شروطًا تجارية مثلى لجميع الأطراف.'
    },
    {
      questionEn: 'How long does it typically take to complete a commercial transaction?',
      questionAr: 'كم من الوقت يستغرق عادة إتمام معاملة تجارية؟',
      answerEn: 'The timeline varies depending on the complexity of the transaction, the industries involved, and regulatory requirements. Simple supplier matching can take 2-4 weeks, while comprehensive deals involving contract negotiation, customs clearance, and logistics coordination may take 2-3 months. We work efficiently to expedite processes while ensuring all due diligence is properly conducted.',
      answerAr: 'يختلف الجدول الزمني حسب تعقيد المعاملة والصناعات المعنية والمتطلبات التنظيمية. يمكن أن يستغرق التوفيق البسيط بين الموردين 2-4 أسابيع، بينما قد تستغرق الصفقات الشاملة التي تتضمن التفاوض على العقود والتخليص الجمركي وتنسيق اللوجستيات 2-3 أشهر. نعمل بكفاءة لتسريع العمليات مع ضمان إجراء جميع عمليات العناية الواجبة بشكل صحيح.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-2 mb-4">
            <i className="ri-question-line text-2xl text-[#D4AF37]"></i>
            <span className="text-sm font-medium text-[#1A5F7A] uppercase tracking-wider">
              {i18n.language === 'ar' ? 'الأسئلة الشائعة' : 'Frequently Asked Questions'}
            </span>
          </div>
          <h2 className="text-5xl font-bold mb-6 leading-tight">
            <div className="text-[#0A2647]">
              {i18n.language === 'ar' ? 'هل لديك أسئلة؟' : 'Have Questions?'}
            </div>
            <div className="bg-gradient-to-r from-[#1A5F7A] to-[#D4AF37] bg-clip-text text-transparent">
              {i18n.language === 'ar' ? 'نحن هنا للمساعدة' : "We're Here to Help"}
            </div>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {i18n.language === 'ar'
              ? 'تعرف على المزيد حول خدماتنا وكيف يمكننا مساعدتك في تحقيق أهدافك التجارية'
              : 'Learn more about our services and how we can help you achieve your commercial objectives'}
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl border border-gray-200 overflow-hidden hover:border-[#D4AF37]/30 transition-all"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left cursor-pointer hover:bg-gray-50 transition-colors"
              >
                <h3 className="text-lg font-semibold text-[#0A2647] pr-4">
                  {i18n.language === 'ar' ? faq.questionAr : faq.questionEn}
                </h3>
                <div className={`w-8 h-8 flex items-center justify-center bg-[#1A5F7A]/10 rounded-full flex-shrink-0 transition-transform ${
                  openIndex === index ? 'rotate-180' : ''
                }`}>
                  <i className="ri-arrow-down-s-line text-xl text-[#1A5F7A]"></i>
                </div>
              </button>
              
              {openIndex === index && (
                <div className="px-8 pb-6">
                  <p className="text-gray-600 leading-relaxed">
                    {i18n.language === 'ar' ? faq.answerAr : faq.answerEn}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-6">
            {i18n.language === 'ar' 
              ? 'لم تجد إجابة لسؤالك؟ تواصل معنا مباشرة'
              : "Didn't find the answer you're looking for? Contact us directly"}
          </p>
          <a
            href="#contact"
            className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-[#1A5F7A] to-[#0A2647] text-white rounded-full font-medium hover:shadow-lg transition-all cursor-pointer whitespace-nowrap"
          >
            {i18n.language === 'ar' ? 'اتصل بنا' : 'Contact Us'}
            <i className={`ri-arrow-${i18n.language === 'ar' ? 'left' : 'right'}-line`}></i>
          </a>
        </div>
      </div>
    </section>
  );
}
